/**
 * A blank value is never a translation: storing it makes a language switch
 * skip the key and can blank the published page for that language.
 *
 * @param {*} value
 *
 * @returns {boolean}
 */
export const isBlankTranslation = value => typeof value !== 'string' || value.trim() === ''

/**
 * Drop blank values from a flat `{ id: html }` map.
 *
 * @param {Object<string, string>} map
 *
 * @returns {Object<string, string>}
 */
export const sanitizeLanguageMap = (map = {}) => Object.entries(map || {}).reduce((acc, [key, value]) => {
  if (!isBlankTranslation(value)) {
    acc[key] = value
  }

  return acc
}, {})

/**
 * Drop blank values from every language: `{ lang: { id: html } }`.
 * Languages stay present (possibly empty) so they are still known.
 *
 * @param {Object<string, Object<string, string>>} translations
 *
 * @returns {Object<string, Object<string, string>>}
 */
export const sanitizePageTranslations = (translations = {}) => Object.keys(translations || {}).reduce((acc, language) => {
  acc[language] = sanitizeLanguageMap(translations[language])

  return acc
}, {})
